module.exports = __webpack_public_path__ + "img/rogeria.dcf9dfe4.png";